import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { Injector } from '@angular/core';

export class TimerService {

  private endDate: Date;
  private interval: any;

  value: BehaviorSubject<Date> = new BehaviorSubject(null);

  constructor(public injector: Injector) {

  }

  public start(duration: number): void {
    if (duration && duration > 0) {
      this.stop();
      this.endDate = new Date(new Date().valueOf() + (duration * 1000));
      this.calculateValue();
      this.interval = setInterval(() => this.calculateValue(), 350);
    }
  }

  public stop(): void {
    clearInterval(this.interval);
    let d = new Date();
    d.setTime(0);
    d.setSeconds(0);
    this.value.next(d);
  }

  private calculateValue(): void {
    let remaingSeconds: number = Math.floor((this.endDate.valueOf() - new Date().valueOf()) / 1000);
    if (remaingSeconds >= 0) {
      let d = new Date();
      d.setTime(0);
      d.setSeconds(remaingSeconds);
      this.value.next(d);
    } else {
      this.injector.get(Router).navigate(['/game-view']);
      this.stop();
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/services/countdown/countdown-service.ts